// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2-ktU","title":"ClientInsurance_title__2QcSl","itemText":"ClientInsurance_itemText__35pfN"};